module.exports = __webpack_public_path__ + "static/media/burger-truck.163dc282.gif";